import React, { useState, useEffect, useCallback } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import AdminTabs from "./AdminTabs";
import { format } from "date-fns";
import currencyFlags from "../../Data/CurrencyFlags.json";

const initialFieldValues = {
  companyId: "00000000-0000-0000-0000-000000000000",
  supplierId: "00000000-0000-0000-0000-000000000000",
  parentCompanyId: "00000000-0000-0000-0000-000000000000",
  supplierName: "",
  agentCode: "",
  name: "",
  email: "",
  phoneNumber: "",
  city: "",
  address: "",
  isActive: true,
  apiType: "DEVELOPMENT",
  devapiurl: "",
  devapikey: "",
  devusername: "",
  devpassword: "",
  prodapiurl: "",
  prodapikey: "",
  produsername: "",
  prodpassword: "",
  type: "FLIGHT",
};

// Supplier types constant
const supplierTypes = [
  "FLIGHT",
  "HOTEL",
  "PACKAGES",
  "BUS",
  "TRAINS",
  "CAR",
  "TRANSFER",
  "SIGHTSEEING",
  "VISA",
];

const CompanySuppliers = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [formErrors, setFormErrors] = useState({}); // State for modal form validation
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [apiShow, setAPIShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState("ALL");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [editSupplier, setEditSupplier] = useState({});
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [editBtnLoading, setEditBtnLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [loadingSuppliers, setLoadingSuppliers] = useState(false);
  const [selectedSupplierType, setSelectedSupplierType] = useState("FLIGHT");
  const [supplierForm, setSupplierForm] = useState({});
  const [apiErrors, setApiErrors] = useState({});
  const [apiBtnLoading, setApiBtnLoading] = useState(false);

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
    setEditSupplier({});
    setLogoFile(null);
    setLogoPreview(null);
    setFormErrors({}); // Reset validation errors
  };

  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues(initialFieldValues);

    // Initialize new supplier data
    const newSupplier = {
      companyId: "",
      companyName: "",
      brandName: "",
      email: "",
      phoneNumber: "",
      gstNo: "",
      panCard: "",
      address: "",
      city: "",
      state: "",
      country: "IN",
      currency: "INR",
      primaryDomain: "",
      isActive: true,
      planType: "TRIAL",
      companyType: "SUPPLIER",
      connects: 0,
      isWebsite: false,
      isRenewal: false,
      endDate: new Date(),
      whatsAppNumber: "",
      whatsAppPhoneNumberId: "",
      whatsAppPermanentToken: "",
      isChatBot: false,
      isSupplierAPI: false,
      userType: "SUPPLIER",
    };

    setEditSupplier(newSupplier);
    setLogoPreview(null);
    setLogoFile(null);
    setAddShow(true);
    setFormErrors({}); // Reset validation errors
  };

  const handleAPIClose = () => {
    setAPIShow(false);
    setRecordForEdit(null);
    setSelectedCompany(null);
    setSuppliers([]);
    setSupplierForm({});
    setSelectedSupplierType("FLIGHT");
  };

  // Initialize supplier form function
  const initializeSupplierForm = (supplierType, existingData = null) => {
    if (existingData && existingData.supplierId) {
      return {
        supplierId: existingData.supplierId,
        supplierCompanyId: selectedCompany?.companyId || "",
        isActive: existingData.isActive,
        apiType: existingData.apiType || "DEVELOPMENT",
        devAgentCode: existingData.devAgentCode || "",
        devapiurl: existingData.devapiurl || "",
        devapikey: existingData.devapikey || "",
        devusername: existingData.devusername || "",
        devpassword: existingData.devpassword || "",
        prodAgentCode: existingData.prodAgentCode || "",
        prodapiurl: existingData.prodapiurl || "",
        prodapikey: existingData.prodapikey || "",
        produsername: existingData.produsername || "",
        prodpassword: existingData.prodpassword || "",
        type: supplierType,
        companyId: user?.cid || "",
      };
    }

    return {
      supplierId: "00000000-0000-0000-0000-000000000000",
      supplierCompanyId: selectedCompany?.companyId || "",
      isActive: true,
      apiType: "DEVELOPMENT",
      devAgentCode: "",
      devapiurl: "",
      devapikey: "",
      devusername: "",
      devpassword: "",
      prodAgentCode: "",
      prodapiurl: "",
      prodapikey: "",
      produsername: "",
      prodpassword: "",
      type: supplierType,
      companyId: user?.cid || "",
    };
  };

  // Fetch suppliers for API modal
  const getSuppliers = async (suppliercompanyId) => {
    setLoadingSuppliers(true);
    try {
      const response = await apiService.getSingle(
        config.GETAPIKEYS +
          "?SupplierCompanyId=" +
          suppliercompanyId +
          "&CompanyId=" +
          user?.cid
      );

      let suppliersData = [];

      if (Array.isArray(response)) {
        suppliersData = response;
      } else if (response && Array.isArray(response.data)) {
        suppliersData = response.data;
      } else {
        suppliersData = [];
      }

      setSuppliers(suppliersData);

      // Initialize form for selected supplier type
      const existingSupplier = suppliersData.find(
        (s) => s.type === selectedSupplierType
      );
      setSupplierForm(
        initializeSupplierForm(selectedSupplierType, existingSupplier)
      );
    } catch (error) {
      // Initialize empty form if no suppliers found
      setSupplierForm(initializeSupplierForm(selectedSupplierType));
      setSuppliers([]);
    } finally {
      setLoadingSuppliers(false);
    }
  };

  // Check if a supplier type has data
  const hasSupplierData = (supplierType) => {
    if (!suppliers || !Array.isArray(suppliers) || suppliers.length === 0) {
      return false;
    }
    return !!suppliers.find((s) => s.type === supplierType);
  };

  // Handle Key icon click (updated function)
  const handleKeyClick = async (company) => {
    setSelectedCompany(company);
    setAPIShow(true);
    await getSuppliers(company.companyId);
  };

  // Handle supplier type change
  const handleSupplierTypeChange = async (type) => {
    setSelectedSupplierType(type);

    // Find existing supplier data for the selected type
    const existingSupplier = suppliers.find((s) => s.type === type);
    setSupplierForm(initializeSupplierForm(type, existingSupplier));
  };

  // Handle input change for supplier form
  const handleSupplierInputChange = (field, value) => {
    setSupplierForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Form submission for API modal (single supplier)
  const handleApiSubmit = async (e) => {
    e.preventDefault();
    setApiBtnLoading(true);

    try {
      const submitData = {
        supplierId: supplierForm.supplierId,
        supplierCompanyId: selectedCompany?.companyId,
        isActive: supplierForm.isActive,
        apiType: supplierForm.apiType,
        DEVAgentCode: supplierForm.devAgentCode,
        DEVAPIURL: supplierForm.devapiurl,
        DEVAPIKEY: supplierForm.devapikey,
        DEVUSERNAME: supplierForm.devusername,
        DEVPASSWORD: supplierForm.devpassword,
        PRODAgentCode: supplierForm.prodAgentCode,
        PRODAPIURL: supplierForm.prodapiurl,
        PRODAPIKEY: supplierForm.prodapikey,
        PRODUSERNAME: supplierForm.produsername,
        PRODPASSWORD: supplierForm.prodpassword,
        type: supplierForm.type,
        companyId: user?.cid,
      };

      const isNew =
        submitData.supplierId === "00000000-0000-0000-0000-000000000000";

      try {
        if (isNew) {
          await apiService.create(config.CREATESUPPLIER, submitData);
        } else {
          await apiService.update(config.UPDATESUPPLIER, submitData);
        }

        handleAPIClose();
      } catch (error) {}
    } catch (error) {
    } finally {
      setApiBtnLoading(false);
    }
  };

  // Render supplier form for API modal
  const renderSupplierForm = () => {
    return (
      <div className="row">
        {/* Supplier Type */}
        <div className="col-lg-3 mb-3">
          <label className="form-label">Supplier Type</label>
          <select
            value={selectedSupplierType}
            onChange={(e) => handleSupplierTypeChange(e.target.value)}
            className="form-select"
          >
            {supplierTypes.map((type) => (
              <option key={type} value={type}>
                {type} {hasSupplierData(type) && "✓"}
              </option>
            ))}
          </select>
        </div>

        {/* API Type */}
        <div className="col-lg-3 mb-3">
          <label className="form-label">API Type</label>
          <select
            value={supplierForm.apiType || "DEVELOPMENT"}
            onChange={(e) =>
              handleSupplierInputChange("apiType", e.target.value)
            }
            className="form-select"
          >
            <option value="DEVELOPMENT">DEVELOPMENT</option>
            <option value="PRODUCTION">PRODUCTION</option>
          </select>
        </div>

        {/* Status */}
        <div className="col-lg-3 mb-3">
          <label className="form-label">Status</label>
          <select
            value={
              supplierForm.isActive !== undefined ? supplierForm.isActive : true
            }
            onChange={(e) =>
              handleSupplierInputChange("isActive", e.target.value === "true")
            }
            className="form-select"
          >
            <option value={true}>Active</option>
            <option value={false}>Inactive</option>
          </select>
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">&nbsp;</label>
          <div className="form-text text-center">
            {hasSupplierData(selectedSupplierType) ? (
              <span className="badge bg-success">API Configured ✓</span>
            ) : (
              <span className="badge bg-warning">No API Configured</span>
            )}
          </div>
        </div>

        {/* Development API Configuration */}
        <div className="col-12 mb-3">
          <h6 className="border-bottom pb-2 text-primary font-weight-bold">
            Development API Configuration
          </h6>
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">DEV Agent Code</label>
          <input
            type="text"
            value={supplierForm.devAgentCode || ""}
            onChange={(e) =>
              handleSupplierInputChange("devAgentCode", e.target.value)
            }
            className="form-control"
            placeholder="Please enter development agent code"
          />
        </div>

        <div className="col-lg-6 mb-3">
          <label className="form-label">DEV API URL</label>
          <input
            type="text"
            value={supplierForm.devapiurl || ""}
            onChange={(e) =>
              handleSupplierInputChange("devapiurl", e.target.value)
            }
            className="form-control"
            placeholder="Please enter development API URL"
          />
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">DEV API KEY</label>
          <input
            type="text"
            value={supplierForm.devapikey || ""}
            onChange={(e) =>
              handleSupplierInputChange("devapikey", e.target.value)
            }
            className="form-control"
            placeholder="Please enter development API key"
          />
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">DEV API USERNAME</label>
          <input
            type="text"
            value={supplierForm.devusername || ""}
            onChange={(e) =>
              handleSupplierInputChange("devusername", e.target.value)
            }
            className="form-control"
            placeholder="Please enter development username"
          />
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">DEV API PASSWORD</label>
          <input
            type="password"
            value={supplierForm.devpassword || ""}
            onChange={(e) =>
              handleSupplierInputChange("devpassword", e.target.value)
            }
            className="form-control"
            placeholder="Please enter development password"
          />
        </div>

        {/* Production API Configuration */}
        <div className="col-12 mb-3">
          <h6 className="border-bottom pb-2 text-primary font-weight-bold">
            Production API Configuration
          </h6>
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">PROD Agent Code</label>
          <input
            type="text"
            value={supplierForm.prodAgentCode || ""}
            onChange={(e) =>
              handleSupplierInputChange("prodAgentCode", e.target.value)
            }
            className="form-control"
            placeholder="Please enter production agent code"
          />
        </div>

        <div className="col-lg-6 mb-3">
          <label className="form-label">PROD API URL</label>
          <input
            type="text"
            value={supplierForm.prodapiurl || ""}
            onChange={(e) =>
              handleSupplierInputChange("prodapiurl", e.target.value)
            }
            className="form-control"
            placeholder="Please enter production API URL"
          />
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">PROD API KEY</label>
          <input
            type="text"
            value={supplierForm.prodapikey || ""}
            onChange={(e) =>
              handleSupplierInputChange("prodapikey", e.target.value)
            }
            className="form-control"
            placeholder="Please enter production API key"
          />
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">PROD API USERNAME</label>
          <input
            type="text"
            value={supplierForm.produsername || ""}
            onChange={(e) =>
              handleSupplierInputChange("produsername", e.target.value)
            }
            className="form-control"
            placeholder="Please enter production username"
          />
        </div>

        <div className="col-lg-3 mb-3">
          <label className="form-label">PROD API PASSWORD</label>
          <input
            type="password"
            value={supplierForm.prodpassword || ""}
            onChange={(e) =>
              handleSupplierInputChange("prodpassword", e.target.value)
            }
            className="form-control"
            placeholder="Please enter production password"
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  // Process countries data from currencyFlags.json
  useEffect(() => {
    if (currencyFlags && Array.isArray(currencyFlags)) {
      const sortedCountries = [...currencyFlags].sort((a, b) =>
        a.country.localeCompare(b.country)
      );
      setCountries(sortedCountries);

      const uniqueCurrencies = [];
      const currencyMap = new Map();

      sortedCountries.forEach((country) => {
        if (country.code && !currencyMap.has(country.code)) {
          currencyMap.set(country.code, true);
          uniqueCurrencies.push({
            code: country.code,
            name: country.currency || "",
          });
        }
      });

      uniqueCurrencies.sort((a, b) => a.code.localeCompare(b.code));
      setCurrencies(uniqueCurrencies);
    }
  }, []);

  // Get data with search and filters
  const GetData = async (
    pageNumber,
    search = "",
    type = "ALL",
    status = "ALL"
  ) => {
    try {
      const params = {
        PageSize: pageSize,
        PageNumber: pageNumber,
      };

      if (search) {
        params.search = search;
      }

      if (type && type !== "ALL") {
        params.type = type;
      }

      if (status && status !== "ALL") {
        params.status = status === "ACTIVE";
      }

      const res = await apiService.getWithParams(
        `${config.GETCOMPANIES}?companyType=SUPPLIER`,
        params
      );

      if (res) {
        setLists(res.data);
        setPageNumber(res.pageNumber);
        setPageSize(res.pageSize);
        setTotalPages(res.totalPages);
        setData(res.data);
        setTotalRecords(res.totalRecords);
      }
    } catch (error) {}
  };

  // Search handler for real-time dropdown using getWithParams
  const handleSearchChange = async (term) => {
    setSearchTerm(term);

    if (term.length >= 2) {
      setIsSearching(true);
      setShowDropdown(true);
      try {
        const params = {
          search: term,
          PageSize: 10,
          PageNumber: 1,
        };

        if (typeFilter && typeFilter !== "ALL") {
          params.type = typeFilter;
        }

        if (statusFilter && statusFilter !== "ALL") {
          params.status = statusFilter === "ACTIVE";
        }

        const res = await apiService.getWithParams(
          `${config.GETCOMPANIES}?companyType=SUPPLIER`,
          params
        );

        if (res) {
          setSearchResults(res.data);
        } else {
          setSearchResults([]);
        }
      } catch (error) {
        setSearchResults([]);
      } finally {
        setIsSearching(false);
      }
    } else {
      setSearchResults([]);
      setShowDropdown(false);
      setIsSearching(false);
    }
  };

  // Handle type filter change
  const handleTypeChange = (type) => {
    setTypeFilter(type);
    setShowDropdown(false);
    GetData(1, searchTerm, type, statusFilter);
  };

  // Handle status filter change
  const handleStatusChange = (status) => {
    setStatusFilter(status);
    setShowDropdown(false);
    GetData(1, searchTerm, typeFilter, status);
  };

  // Perform main search (update the table)
  const performSearch = () => {
    setShowDropdown(false);
    GetData(1, searchTerm, typeFilter, statusFilter);
  };

  // Supplier selection from dropdown
  const handleSupplierSelect = (supplier) => {
    setSearchTerm(supplier.companyName);
    setShowDropdown(false);
    setLists([supplier]);
    setTotalRecords(1);
    setTotalPages(1);
  };

  // Clear all filters
  const handleClearFilters = () => {
    setSearchTerm("");
    setTypeFilter("ALL");
    setStatusFilter("ALL");
    setSearchResults([]);
    setShowDropdown(false);
    GetData(1);
  };

  const GetLastPageData = () => {
    GetData(totalPages, searchTerm, typeFilter, statusFilter);
  };

  const GetFirstPageData = () => {
    GetData(1, searchTerm, typeFilter, statusFilter);
  };

  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number)
      GetData(number, searchTerm, typeFilter, statusFilter);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const showEditDetails = (data) => {
    const cleanedData = {};
    Object.keys(data).forEach((key) => {
      if (
        data[key] === null ||
        data[key] === "null" ||
        data[key] === "undefined"
      ) {
        cleanedData[key] = "";
      } else {
        cleanedData[key] = data[key];
      }
    });

    setEditSupplier(cleanedData);
    setLogoPreview(cleanedData.logoUrl || cleanedData.logoSrc);
    setAddShow(true);
  };

  const showAPIDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAPIShow(true);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETESUPPLIER, itemToDelete);
        await GetData(pageNumber, searchTerm, typeFilter, statusFilter);
      } catch (error) {}
      handleCloseDeleteModal();
    }
  };

  // Handle file change for logo
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  // Handle country change
  const handleCountryChange = (countryCode) => {
    const selectedCountry = countries.find(
      (country) => country.countryCode === countryCode
    );
    setEditSupplier({
      ...editSupplier,
      country: countryCode,
      currency: selectedCountry?.code || "",
    });
  };

  // Handle currency change
  const handleCurrencyChange = (currencyCode) => {
    setEditSupplier({
      ...editSupplier,
      currency: currencyCode,
    });
  };

  // Check if country is India
  const isIndia = (countryCode) => {
    return countryCode === "IN";
  };

  // Handle input change for edit form
  const handleEditInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldsToUppercase = [
      "companyName",
      "brandName",
      "city",
      "state",
      "gstNo",
      "panCard",
    ];

    setEditSupplier({
      ...editSupplier,
      [name]:
        type === "checkbox"
          ? checked
          : fieldsToUppercase.includes(name)
          ? value.toUpperCase()
          : value,
    });

    // Clear the specific error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: null,
      });
    }
  };

  // Validation logic for the supplier form
  const validateSupplierForm = () => {
    const newErrors = {};

    // Company Name validation
    if (!editSupplier.companyName || editSupplier.companyName.trim() === "") {
      newErrors.companyName = "Company Name is required.";
    }

    // Brand Name validation
    if (!editSupplier.brandName || editSupplier.brandName.trim() === "") {
      newErrors.brandName = "Brand Name is required.";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!editSupplier.email || !emailRegex.test(editSupplier.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    // Phone Number validation
    const phoneRegex = /^\d{10,15}$/;
    if (
      !editSupplier.phoneNumber ||
      !phoneRegex.test(editSupplier.phoneNumber)
    ) {
      newErrors.phoneNumber =
        "Please enter a valid phone number (10-15 digits).";
    }

    setFormErrors(newErrors);
    // Return true if there are no errors
    return Object.keys(newErrors).length === 0;
  };

  // Handle update supplier (client-style)
  const handleUpdateSupplier = async (e) => {
    e.preventDefault();
    if (validateSupplierForm()) {
      // Use the new validation function
      setEditBtnLoading(true);

      try {
        if (!editSupplier.companyId) {
          // Create new supplier
          const newSupplierData = {
            companyName: editSupplier.companyName || "",
            brandName: editSupplier.brandName || "",
            email: editSupplier.email || "",
            phoneNumber: editSupplier.phoneNumber || "",
            gstNo: editSupplier.gstNo || "",
            panCard: editSupplier.panCard || "",
            address: editSupplier.address || "",
            city: editSupplier.city || "",
            state: editSupplier.state || "",
            country: editSupplier.country || "",
            currency: editSupplier.currency || "",
            companyType: "SUPPLIER",
            parentCompanyId: user?.cid,
            isActive: editSupplier.isActive,
            planType: "TRIAL",
            primaryDomain: editSupplier.primaryDomain || "",
            connects: editSupplier.connects || 0,
            isWebsite: editSupplier.isWebsite || false,
            isRenewal: editSupplier.isRenewal || false,
            endDate: editSupplier.endDate || new Date(),
            whatsAppNumber: editSupplier.whatsAppNumber || "",
            whatsAppPhoneNumberId: editSupplier.whatsAppPhoneNumberId || "",
            whatsAppPermanentToken: editSupplier.whatsAppPermanentToken || "",
            isChatBot: editSupplier.isChatBot || false,
            isSupplierAPI: editSupplier.isSupplierAPI || false,
            userType: "SUPPLIER",
            password: "App@000",
            type: editSupplier.type || "FLIGHT",
          };

          const response = await apiService.create(
            config.CREATECOMPANYBYSUPERADMIN,
            newSupplierData
          );

          if (response && response.success) {
            await GetData(pageNumber);
            handleAddClose();
          } else {
          }
        } else {
          // Update existing supplier
          const formData = new FormData();

          formData.append("companyId", editSupplier.companyId);
          formData.append("companyName", editSupplier.companyName || "");
          formData.append("brandName", editSupplier.brandName || "");
          formData.append("email", editSupplier.email || "");
          formData.append("phoneNumber", editSupplier.phoneNumber || "");
          formData.append("gstNo", editSupplier.gstNo || "");
          formData.append("panCard", editSupplier.panCard || "");
          formData.append("address", editSupplier.address || "");
          formData.append("city", editSupplier.city || "");
          formData.append("state", editSupplier.state || "");
          formData.append("country", editSupplier.country || "");
          formData.append("currency", editSupplier.currency || "");
          formData.append("primaryDomain", editSupplier.primaryDomain || "");
          formData.append("isActive", editSupplier.isActive);
          formData.append("planType", editSupplier.planType || "");
          formData.append("connects", editSupplier.connects || 0);
          formData.append("isWebsite", editSupplier.isWebsite || false);
          formData.append("isRenewal", editSupplier.isRenewal || false);
          formData.append("endDate", editSupplier.endDate || "");
          formData.append("whatsAppNumber", editSupplier.whatsAppNumber || "");
          formData.append(
            "whatsAppPhoneNumberId",
            editSupplier.whatsAppPhoneNumberId || ""
          );
          formData.append(
            "whatsAppPermanentToken",
            editSupplier.whatsAppPermanentToken || ""
          );
          formData.append("isChatBot", editSupplier.isChatBot || false);
          formData.append("isSupplierAPI", editSupplier.isSupplierAPI || false);

          if (logoFile) {
            formData.append("logoFile", logoFile);
          }

          await apiService.update(config.UPDATECOMPANYBYSUPERADMIN, formData);
          await GetData(pageNumber);
          handleAddClose();
        }
      } catch (error) {
      } finally {
        setEditBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldsToUppercase = ["supplierName", "city"];
    setValues({
      ...values,
      [name]: fieldsToUppercase.includes(name) ? value.toUpperCase() : value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setAPIShow(false);
    setBtnLoading(false);
  };

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return format(new Date(dateString), "dd MMM, yyyy hh:mm a");
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <AdminTabs pageName="SUPPLIERCOMPANIES" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    {/* Search and Filters Section */}
                    <div className="col-sm-8">
                      <div className="d-flex gap-2 align-items-center flex-wrap">
                        {/* Search Input with Dropdown */}
                        <div className="search-box position-relative flex-grow-1">
                          <input
                            type="text"
                            className="form-control search"
                            placeholder="Search by supplier name..."
                            value={searchTerm}
                            onChange={(e) => handleSearchChange(e.target.value)}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                performSearch();
                              }
                            }}
                          />

                          {/* Search Results Dropdown */}
                          {showDropdown && (
                            <div
                              className="dropdown-menu show w-100"
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                zIndex: 1000,
                                maxHeight: "200px",
                                overflowY: "auto",
                                border: "1px solid #dee2e6",
                                borderRadius: "0.375rem",
                                boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
                                display: "block",
                              }}
                            >
                              {isSearching ? (
                                <div className="dropdown-item text-center">
                                  <div
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </div>
                                  <span className="ms-2">Searching...</span>
                                </div>
                              ) : searchResults.length > 0 ? (
                                searchResults.map((supplier) => (
                                  <button
                                    key={supplier.companyId}
                                    type="button"
                                    className="dropdown-item"
                                    onClick={() =>
                                      handleSupplierSelect(supplier)
                                    }
                                    style={{
                                      border: "none",
                                      background: "white",
                                      padding: "8px 16px",
                                      width: "100%",
                                      textAlign: "left",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.background = "#f8f9fa")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.background = "white")
                                    }
                                  >
                                    <div>
                                      <strong>{supplier.companyName}</strong>
                                      <span
                                        className={`badge ms-2 ${
                                          supplier.isActive
                                            ? "bg-success"
                                            : "bg-danger"
                                        }`}
                                        style={{ fontSize: "0.7em" }}
                                      >
                                        {supplier.isActive
                                          ? "ACTIVE"
                                          : "INACTIVE"}
                                      </span>
                                      <span
                                        className="badge bg-info ms-2"
                                        style={{ fontSize: "0.7em" }}
                                      >
                                        {supplier.type}
                                      </span>
                                    </div>
                                    <small className="text-muted">
                                      {supplier.email} • {supplier.phoneNumber}
                                    </small>
                                  </button>
                                ))
                              ) : searchTerm.length >= 2 ? (
                                <div className="dropdown-item text-muted text-center">
                                  No suppliers found
                                </div>
                              ) : null}
                            </div>
                          )}
                        </div>

                        {/* Type Filter */}
                        <div className="flex-shrink-0">
                          <select
                            className="form-select form-select-sm"
                            value={typeFilter}
                            onChange={(e) => handleTypeChange(e.target.value)}
                            style={{
                              height: "38px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <option value="ALL">All Types</option>
                            <option value="FLIGHT">FLIGHT</option>
                            <option value="HOTEL">HOTEL</option>
                            <option value="PACKAGES">PACKAGES</option>
                            <option value="BUS">BUS</option>
                            <option value="TRAINS">TRAINS</option>
                            <option value="CAR">CARS</option>
                            <option value="TRANSFER">TRANSFERS</option>
                            <option value="SIGHTSEEING">SIGHTSEEING</option>
                            <option value="VISA">VISAS</option>
                          </select>
                        </div>

                        {/* Status Filter */}
                        <div className="flex-shrink-0">
                          <select
                            className="form-select form-select-sm"
                            value={statusFilter}
                            onChange={(e) => handleStatusChange(e.target.value)}
                            style={{
                              height: "38px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <option value="ALL">All Status</option>
                            <option value="ACTIVE">Active</option>
                            <option value="INACTIVE">Inactive</option>
                          </select>
                        </div>

                        {/* Action Buttons */}
                        <div className="d-flex gap-2">
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={handleClearFilters}
                            style={{
                              height: "38px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-4 ms-auto">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          Supplier Company
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>S.No</th>
                          <th>Supplier</th>
                          <th>Contact</th>
                          <th>Status</th>
                          <th>Connects & Plan</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 ? (
                          lists.map((v, index) => (
                            <tr key={v.companyId}>
                              <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                              <td>
                                {v.companyName}
                                <br />
                                {v.type}
                              </td>
                              <td>
                                {v.email} <br />
                                {v.phoneNumber}
                              </td>
                              <td>
                                {v.isActive === true ? (
                                  <span className="badge bg-success me-2">
                                    STATUS : ACTIVE
                                  </span>
                                ) : (
                                  <span className="badge bg-danger me-2">
                                    STATUS : IN-ACTIVE
                                  </span>
                                )}
                                <br />
                                {v.isSupplierAPI === true ? (
                                  <span className="badge bg-success me-2">
                                    IS API ? : YES
                                  </span>
                                ) : (
                                  <span className="badge bg-danger me-2">
                                    IS API ? : NO
                                  </span>
                                )}
                              </td>
                              <td>
                                {v.connects} connects
                                <br />
                                <span className="badge bg-success me-2">
                                  {v.planType} Plan
                                </span>
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-info" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.companyId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill text-danger align-bottom" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="APIKEYS"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) => handleKeyClick(v)}
                                    >
                                      <i className="ri-key-fill text-primary align-bottom" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center py-4">
                              <div className="text-muted">
                                <i className="ri-user-shared-line display-4"></i>
                                <p className="mt-2">
                                  {searchTerm ||
                                  typeFilter !== "ALL" ||
                                  statusFilter !== "ALL"
                                    ? "No suppliers found matching your criteria"
                                    : "No suppliers found"}
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + (pageNumber === 1 ? " disabled" : "")
                        }
                        onClick={() => pageNumber > 1 && GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" +
                          (pageNumber === totalPages ? " disabled" : "")
                        }
                        onClick={() =>
                          pageNumber < totalPages && GetLastPageData()
                        }
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* New Add/Edit Supplier Modal (Client Style) */}
        <Modal
          show={addShow}
          onHide={handleAddClose}
          size="lg"
          centered
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {editSupplier.companyId
                ? `Edit Supplier - ${editSupplier.companyName}`
                : "Add New Supplier"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <div className="container-fluid">
              {/* Company Logo */}
              <div className="row mb-4">
                <label className="col-sm-3 col-form-label">Company Logo:</label>
                <div className="col-sm-9">
                  <div className="d-flex align-items-center gap-3">
                    {logoPreview ? (
                      <img
                        src={logoPreview}
                        alt="Company Logo"
                        className="img-thumbnail"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "contain",
                        }}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    ) : (
                      <div
                        className="img-thumbnail d-flex align-items-center justify-content-center"
                        style={{
                          width: "120px",
                          height: "120px",
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #dee2e6",
                        }}
                      >
                        <i className="ri-building-2-line text-muted fs-2"></i>
                      </div>
                    )}
                    {addShow && (
                      <div className="flex-grow-1">
                        <input
                          type="file"
                          className="form-control"
                          accept="image/png, image/jpeg, image/gif"
                          onChange={handleFileChange}
                        />
                        <div className="form-text">
                          Recommended size: 120x120px. Supports PNG, JPG, GIF.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Company Name */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Company Name:</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className={`form-control ${
                      formErrors.companyName ? "is-invalid" : ""
                    }`}
                    value={editSupplier.companyName || ""}
                    maxLength={40}
                    name="companyName"
                    onChange={handleEditInputChange}
                    placeholder="Enter company name"
                  />
                  {formErrors.companyName && (
                    <div className="invalid-feedback">
                      {formErrors.companyName}
                    </div>
                  )}
                </div>
              </div>

              {/* Brand Name */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Brand Name:</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className={`form-control ${
                      formErrors.brandName ? "is-invalid" : ""
                    }`}
                    value={editSupplier.brandName || ""}
                    maxLength={40}
                    name="brandName"
                    onChange={handleEditInputChange}
                    placeholder="Enter brand name"
                  />
                  {formErrors.brandName && (
                    <div className="invalid-feedback">
                      {formErrors.brandName}
                    </div>
                  )}
                </div>
              </div>

              {/* Email */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Email:</label>
                <div className="col-sm-9">
                  <input
                    type="email"
                    className={`form-control ${
                      formErrors.email ? "is-invalid" : ""
                    }`}
                    value={editSupplier.email || ""}
                    maxLength={40}
                    name="email"
                    onChange={handleEditInputChange}
                    placeholder="Enter email address"
                  />
                  {formErrors.email && (
                    <div className="invalid-feedback">{formErrors.email}</div>
                  )}
                </div>
              </div>

              {/* Phone */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Phone:</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className={`form-control ${
                      formErrors.phoneNumber ? "is-invalid" : ""
                    }`}
                    value={editSupplier.phoneNumber || ""}
                    maxLength={15}
                    name="phoneNumber"
                    onChange={handleEditInputChange}
                    placeholder="Enter phone number"
                  />
                  {formErrors.phoneNumber && (
                    <div className="invalid-feedback">
                      {formErrors.phoneNumber}
                    </div>
                  )}
                </div>
              </div>
              {/* Address */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Address:</label>
                <div className="col-sm-9">
                  <textarea
                    className="form-control"
                    value={editSupplier.address || ""}
                    maxLength={250}
                    name="address"
                    onChange={handleEditInputChange}
                    placeholder="Enter address"
                    rows="3"
                  />
                </div>
              </div>
              {/* City */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">City:</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    value={editSupplier.city || ""}
                    maxLength={40}
                    name="city"
                    onChange={handleEditInputChange}
                    placeholder="Enter city"
                  />
                </div>
              </div>

              {/* State */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">State:</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    value={editSupplier.state || ""}
                    maxLength={40}
                    name="state"
                    onChange={handleEditInputChange}
                    placeholder="Enter state"
                  />
                </div>
              </div>

              {/* Country */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Country:</label>
                <div className="col-sm-9">
                  <select
                    className="form-select"
                    value={editSupplier.country || ""}
                    name="country"
                    onChange={(e) => handleCountryChange(e.target.value)}
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option
                        key={country.countryCode}
                        value={country.countryCode}
                      >
                        {country.flag && (
                          <img
                            src={country.flag}
                            alt={country.country}
                            style={{
                              width: "20px",
                              height: "15px",
                              marginRight: "8px",
                              verticalAlign: "middle",
                            }}
                          />
                        )}
                        {country.country} - {country.countryCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Currency */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Currency:</label>
                <div className="col-sm-9">
                  <select
                    className="form-select"
                    value={editSupplier.currency || ""}
                    onChange={(e) => handleCurrencyChange(e.target.value)}
                  >
                    <option value="">Select Currency</option>
                    {countries.map((country) => (
                      <option key={country.countryCode} value={country.code}>
                        {country.flag && (
                          <img
                            src={country.flag}
                            alt={country.country}
                            style={{
                              width: "20px",
                              height: "15px",
                              marginRight: "8px",
                              verticalAlign: "middle",
                            }}
                          />
                        )}
                        {country.country} - {country.code}
                        {country.currency && ` (${country.currency})`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* GST No / Tax No - Conditionally rendered based on country */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">
                  {isIndia(editSupplier.country) ? "GST No:" : "Tax No:"}
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    value={editSupplier.gstNo || ""}
                    maxLength={15}
                    name="gstNo"
                    onChange={handleEditInputChange}
                    placeholder={
                      isIndia(editSupplier.country)
                        ? "Enter GST number"
                        : "Enter tax number"
                    }
                  />
                </div>
              </div>

              {/* Pan Card - Only show for India */}
              {isIndia(editSupplier.country) && (
                <div className="row mb-3">
                  <label className="col-sm-3 col-form-label">Pan Card:</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      value={editSupplier.panCard || ""}
                      maxLength={15}
                      name="panCard"
                      onChange={handleEditInputChange}
                      placeholder="Enter PAN card number"
                    />
                  </div>
                </div>
              )}

              {/* WhatsApp Number */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">
                  WhatsApp Number:
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    value={editSupplier.whatsAppNumber || ""}
                    maxLength={15}
                    name="whatsAppNumber"
                    onChange={handleEditInputChange}
                    placeholder="Enter WhatsApp number"
                  />
                </div>
              </div>

              {/* Primary Domain */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">
                  Primary Domain:
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    value={editSupplier.primaryDomain || ""}
                    maxLength={100}
                    name="primaryDomain"
                    onChange={handleEditInputChange}
                    placeholder="e.g., https://example.com"
                  />
                </div>
              </div>
              {/* Plan Type */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Plan Type:</label>
                <div className="col-sm-9">
                  <select
                    className="form-select"
                    value={editSupplier.planType || "TRIAL"}
                    name="planType"
                    onChange={handleEditInputChange}
                  >
                    <option value="TRIAL">TRIAL</option>
                    <option value="MONTHLYSTARTER">MONTHLYSTARTER</option>
                    <option value="MONTHLYPRO">MONTHLYPRO</option>
                    <option value="MONTHLYENTERPRISE">MONTHLYENTERPRISE</option>
                  </select>
                </div>
              </div>

              {/* Connects */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Connects:</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    value={editSupplier.connects || 0}
                    name="connects"
                    onChange={handleEditInputChange}
                    placeholder="Enter number of connects"
                  />
                </div>
              </div>

              {/* End Date */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">End Date:</label>
                <div className="col-sm-9">
                  <input
                    type="datetime-local"
                    className="form-control"
                    value={
                      editSupplier.endDate
                        ? new Date(editSupplier.endDate)
                            .toISOString()
                            .slice(0, 16)
                        : ""
                    }
                    name="endDate"
                    onChange={handleEditInputChange}
                  />
                </div>
              </div>

              {/* Status */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Status:</label>
                <div className="col-sm-9">
                  <select
                    className="form-select"
                    value={editSupplier.isActive}
                    name="isActive"
                    onChange={handleEditInputChange}
                  >
                    <option value={true}>Active</option>
                    <option value={false}>Inactive</option>
                  </select>
                </div>
              </div>

              {/* Separated Features Section */}
              <div className="row mb-3">
                <div className="col-12">
                  <h6 className="border-bottom pb-2 mb-3">Features</h6>
                </div>
              </div>

              {/* Website Feature */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Website:</label>
                <div className="col-sm-9">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={editSupplier.isWebsite || false}
                      name="isWebsite"
                      onChange={handleEditInputChange}
                    />
                    <label className="form-check-label">
                      Enable Website Feature
                    </label>
                  </div>
                </div>
              </div>

              {/* Chat Bot Feature */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Chat Bot:</label>
                <div className="col-sm-9">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={editSupplier.isChatBot || false}
                      name="isChatBot"
                      onChange={handleEditInputChange}
                    />
                    <label className="form-check-label">
                      Enable Chat Bot Feature
                    </label>
                  </div>
                </div>
              </div>

              {/* Supplier API Feature */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Supplier API:</label>
                <div className="col-sm-9">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={editSupplier.isSupplierAPI || false}
                      name="isSupplierAPI"
                      onChange={handleEditInputChange}
                    />
                    <label className="form-check-label">
                      Enable Supplier API Feature
                    </label>
                  </div>
                </div>
              </div>

              {/* Renewal Feature */}
              <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Renewal:</label>
                <div className="col-sm-9">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={editSupplier.isRenewal || false}
                      name="isRenewal"
                      onChange={handleEditInputChange}
                    />
                    <label className="form-check-label">
                      Enable Auto Renewal
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-center w-100">
              {editBtnLoading ? (
                <button className="btn btn-success me-2 px-4" disabled>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {editSupplier.companyId ? "Saving..." : "Creating..."}
                </button>
              ) : (
                <button
                  className="btn btn-success me-2 px-4"
                  onClick={handleUpdateSupplier}
                >
                  <i className="fas fa-save me-2"></i>
                  {editSupplier.companyId ? "Save Changes" : "Create Supplier"}
                </button>
              )}
              <button className="btn btn-danger px-4" onClick={handleAddClose}>
                <i className="fas fa-times me-2"></i>Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* UPDATED API Details Modal - Single supplier type with dropdown */}
        <Modal show={apiShow} onHide={handleAPIClose} size="xl" scrollable>
          <Modal.Header closeButton>
            <Modal.Title>
              Supplier API Details - {selectedCompany?.companyName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Info Alert */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="alert alert-info mb-0">
                  <i className="ri-information-line me-1"></i>
                  Managing API details for:{" "}
                  <strong>{selectedCompany?.companyName}</strong>
                </div>
              </div>
            </div>

            {loadingSuppliers ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading supplier APIs...</p>
              </div>
            ) : (
              <form onSubmit={handleApiSubmit} autoComplete="off" noValidate>
                {renderSupplierForm()}

                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {apiBtnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        Save {selectedSupplierType} API
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Saving...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleAPIClose}
                    >
                      Close
                    </button>
                  </div>
                </Modal.Footer>
              </form>
            )}
          </Modal.Body>
        </Modal>

        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default CompanySuppliers;
